module.exports = __webpack_public_path__ + "static/0038-1eab911ef76bb399be0efe1304154ea6.png";